<template>
<div class="chapter">
<div class="inner_page">
<h1>Table des Matières</h1>
<p><a href="#/c001">Dream's Boy - Journal d'une sorcière | Valeria De Luca</a></p>
<p><span href="#/c002" title="Link target outside of Sample">♠Fabrizio Caramagna♠</span></p>
<p><span href="#/c003" title="Link target outside of Sample">♠Vasco Rossi – Ridere di Te♠</span></p>
<p><span href="#/c004" title="Link target outside of Sample">Richard Bach</span></p>
<p><span href="#/c005" title="Link target outside of Sample">Jane Eyre – Charlotte Brontë</span></p>
<p><span href="#/c006" title="Link target outside of Sample">Bram Stocker</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Prière indienne sur l'amour.</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Paul Verlaine.</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Infinite Dreams – Iron Maiden.</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Isabel De Santis</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Mémoires d’une sorcière – Giovanna Iammucci</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Richard Bach</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Osho</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Fabrizio Caramagna</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Agostino Degas</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Platon, Le Banquet</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Fin</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?586d1e0e